import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import APP_ROUTES from "../../../../routers/routeConstants";

import { FEED_QUERY_KEYS } from "../queryKeys";
import { CreatePostFormData } from "../types/feed.types";
import { updateBasicPost } from "../services/postServices";

interface UseUpdateBasicPostMutationProps {
  postId: number;
}

export const useUpdateBasicPostMutation = ({ postId }: UseUpdateBasicPostMutationProps) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation("feed", { keyPrefix: "toast" });

  const updatePostMutation = useMutation({
    mutationFn: (data: CreatePostFormData) => updateBasicPost(postId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...FEED_QUERY_KEYS.all, "posts", "list"] });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.postData(postId) });
      navigate(APP_ROUTES.FEED);
      toast.success(t("postUpdatedSuccessfully"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    },
  });

  return {
    updatePost: updatePostMutation.mutate,
    isUpdating: updatePostMutation.isPending,
    error: updatePostMutation.error,
  };
};
